// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"qw_a","ListOfForumsRight__brandDaysPosts":"qw_b bik_sw"};